import { getCurrentTenant } from '@/utils/tenant'
import { getTenantComponent } from '@/config/tenants.config'

// ===== 初始化当前租户 =====
let tenant: any
try {
  tenant = getCurrentTenant()
} catch (e) {
  console.warn('[Routes] 获取租户配置失败，使用默认配置:', e)
  tenant = { id: 'default', features: { register: true, forgotPassword: true } }
}

export const routes = [
  // 入口页面（首次访问，配置服务器）
  {
    name: 'rootLayout',
    path: '/',
    component: () => import('@/layout/basic/index.vue'),
    children: [
      // 移除 root 路由，不再需要
      // {
      //   path: 'root',
      //   component: () => import('@/layout/components/root/index.vue'),
      //   meta: {
      //     title: 'root', 
      //   },
      // },
      // {
      //   path: 'menu',
      //   component: () => import('@/layout/components/root/menu.vue'),
      //   meta: {
      //     title: 'menu', 
      //   },
      // },
      // {
      //   path: 'member',
      //   component: () => import('@/layout/components/member/index.vue'),
      //   meta: {
      //     title: 'tabbar.member',
      //     keepAlive: true,
      //   },
      // },
    ],
  },
  // 登录
  {
    name: 'login',
    path: '/login',
    component: () => getTenantComponent(tenant?.id || 'default', 'login'),
    meta: { title: 'login.title', skipAuth: true, keepAlive: true },
  },
  {
    name: 'loading',
    path: '/loading',
    component: () => import('@/layout/components/loading.vue'),
    meta: { title: '加载中', skipAuth: true },
  },
  {
    name: 'ad',
    path: '/ad',
    component: () => import('@/layout/services/AdPage.vue'),
    meta: { title: '广告', skipAuth: true },
  },
  // 服务器配置
  {
    name: 'serverConfig',
    path: '/server-config',
    component: () => import('@/layout/services/serve.vue'),
    meta: { title: 'settings.serverConfig', skipAuth: true },
  },
  { name: 'serve', path: '/serve', redirect: '/server-config' },
  // 日志查看
  {
    name: 'logs',
    path: '/page/logs',
    component: () => import('@/capacitor/logger/simplelogviewer.vue'),
    meta: { title: '日志查看', keepAlive: true },
  },
  // 修改密码
  {
    name: 'pass',
    path: '/pass',
    component: () => import('@/layout/components/member/pass.vue'),
    meta: { title: 'tabbar.pass', keepAlive: true },
  },
  // 上传头像
  {
    name: 'uploadAvatar',
    path: '/uploadAvatar',
    component: () => import('@/layout/components/member/uploadAvatar.vue'),
    meta: { title: 'tabbar.uploadAvatar', keepAlive: true },
  },
  // 注册（根据租户功能开关）
  ...(tenant.features.register ? [{
    name: 'register',
    path: '/register',
    component: () => getTenantComponent(tenant?.id || 'default', 'register'),
    meta: { title: 'register.title', skipAuth: true, keepAlive: true },
  }] : []),
  // 忘记密码（根据租户功能开关）
  ...(tenant.features.forgotPassword ? [{
    name: 'forgotPassword',
    path: '/forgotPassword',
    component: () => getTenantComponent(tenant?.id || 'default', 'forgotPassword'),
    meta: { title: 'forgotPassword.title', skipAuth: true, keepAlive: true },
  }] : []),
  // 用户协议
  {
    name: 'protocol',
    path: '/protocol',
    component: () => import('@/views/protocol/index.vue'),
    meta: { title: '用户协议', skipAuth: true },
  },
  // 隐私政策
  {
    name: 'privacy',
    path: '/privacy',
    component: () => import('@/views/privacy/index.vue'),
    meta: { title: '隐私政策', skipAuth: true },
  },
  // 默认协议
  {
    name: 'default-protocol',
    path: '/default-protocol',
    component: () => import('@/views/protocol/default-protocol.vue'),
    meta: { title: '用户协议', skipAuth: true },
  },
  // 默认隐私政策
  {
    name: 'default-privacy',
    path: '/default-privacy',
    component: () => import('@/views/privacy/default-privacy.vue'),
    meta: { title: '隐私政策', skipAuth: true },
  },
  // 版本历史（热更新管理）
  {
    name: 'versionHistory',
    path: '/version-history',
    component: () => import('@/capacitor/updater/VersionHistory.vue'),
    meta: { title: '版本历史', skipAuth: true },
  },
  // 兜底路由
  // {
  //   path: '/:pathMatch(.*)',
  //   redirect: '/',
  // },
  // 下载app二维码中转页
  // download
  {
    name: 'download',
    path: '/download',
    component: () => import('@/layout/components/member/download.vue'),
    meta: { title: '下载', skipAuth: true },
  },
];

export default routes;
